import React, { useEffect, useState } from 'react';
import { images } from '../../assets';
import './Breakthrough.css';
import logoSvg from '../../assets/images/logo-small.svg';
import FadeInSection from '../FadeInSection/FadeInSection';

const Breakthrough: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="breakthrough-section">
      <div className="breakthrough-content">
        <div className="breakthrough-text-block">
          <img src={logoSvg} alt="Heal" className="breakthrough-logo" />
          <FadeInSection delay={100}>
            <h2 className="breakthrough-title">
              You are one sound away from your next breakthrough
            </h2>
          </FadeInSection>
          <FadeInSection delay={300}>
            <p className="breakthrough-subtext">
              Experience a measurable shift. Heal helps you regulate your nervous system in as little as 5 minutes
            </p>
          </FadeInSection>
        </div>
        <a
          href={process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/app/heal'}
          target="_blank"
          rel="noopener noreferrer"
          className="breakthrough-cta"
          aria-label="Get HEAL on the App Store"
        >
          <img src={images.ctaLight} alt="Get started" />
        </a>
        <img 
          src={isMobile ? images.breakthroughSmall : images.breakthrough} 
          alt="Breakthrough" 
          className="breakthrough-bg"
        />
      </div>
    </section>
  );
};

export default Breakthrough; 